import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('metrics')

export const SEND_DRIFT_APP_METRIC = makeConstant('SEND_DRIFT_APP_METRIC')
export const SEND_DRIFT_APP_METRIC_PENDING = makeConstant('SEND_DRIFT_APP_METRIC_PENDING')
export const SEND_DRIFT_APP_METRIC_FAILED = makeConstant('SEND_DRIFT_APP_METRIC_FAILED')
export const SEND_DRIFT_APP_METRIC_SUCCESS = makeConstant('SEND_DRIFT_APP_METRIC_SUCCESS')

export const ENTER_ROOT_APP_ROUTE = makeConstant('ENTER_ROOT_APP_ROUTE')
export const START_CONVERSATIONS_APP_TIMER = makeConstant('START_CONVERSATIONS_APP_TIMER')
export const RECORD_CONVERSATIONS_APP_TIMER = makeConstant('RECORD_CONVERSATIONS_APP_TIMER')
export const HIT_CONVERSATIONS_APP_RENDER_CHECKPOINT = makeConstant('HIT_CONVERSATIONS_APP_RENDER_CHECKPOINT')

export const TRACK_PRESENCE_LOAD_TIME = makeConstant('TRACK_PRESENCE_LOAD_TIME')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/driftAppMetrics/constants.js